function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandfeuermelder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "black",
    strokeWidth: 2,
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeLinecap: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,23.5L23.5,23.5",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,1.5L1.5,1.5",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,23.5L23.5,1.5",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,1.5L1.5,23.5",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,12.029L12.5,19.257",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.214,5.743C6.214,9.214 9.028,12.029 12.5,12.029C15.972,12.029 18.786,9.214 18.786,5.743",
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandfeuermelder);
export default __webpack_public_path__ + "static/media/handfeuermelder.cc7ff5b8e2b74e629a01465664ed37bf.svg";
export { ForwardRef as ReactComponent };